import { commonPlugins } from '../common';
import { componentPlugins } from '../component';
import { FragmentLifeCycleMarkerComponentProcessor } from './component';
import { LiveDOMRenderer } from './live-renderer';
import { domPlugins } from './plugins';
export * from './renderer';
export * from './util/life-cycle';
export * from './live-renderer';
export * from './plugins';
export * from './component';
export class CommonDOMRenderer extends LiveDOMRenderer {
    constructor(dom = window) {
        super(dom, ...componentPlugins(), () => new FragmentLifeCycleMarkerComponentProcessor(), ...commonPlugins(), ...domPlugins());
    }
}
//# sourceMappingURL=index.js.map